import React, { useCallback, useEffect, useRef, useState } from 'react';
import { format } from 'date-fns';
import { useDebounce } from '@react-hook/debounce';

import {
  colors,
  Box,
  Paper,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Grid,
  TextField,
  FormLabel,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Button,
  FormHelperText,
  Autocomplete,
} from '@material-ui/core';
import DateTimePicker from '@material-ui/lab/DateTimePicker';

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import { makeStyles } from '@material-ui/styles';

import CombineSelector from '../../components/combineSelector';
import { useAPI } from '../../utils/api';
import { useAuth } from '../../utils/auth';
import Dialog from '../../components/dialog/base';
import Selector from '../../components/selector';
import VariableTextField from '../../components/variableTextField';
import { useDialog } from '../../utils/dialog';
import { useHistory, useParams } from 'react-router-dom';
import { getHrefUrl } from '../../utils/printOrderConvert';

const STEP = {
  1: { INDEX: 0, NAME: '取件方' },
  2: { INDEX: 1, NAME: '送達方' },
  3: { INDEX: 2, NAME: '配送訊息' },
  FINAL: { INDEX: 3, NAME: '列印簽單' },
};

const STEPS = [STEP[1], STEP[2], STEP[3], STEP.FINAL];

// 4: 取付; 5: 送付
const PAYMENT_METHOD_NEED_TAXID = new Set(['4', '5']);

const SPECIAL_SUB_OPTIONS = {
  USE_SUB: '1',
  USE_OTHER: '9999',
};

const SPECIAL_SUB_Template = {
  id: 0,
  code: '',
  description: '',
};

const useStyles = makeStyles({
  option: {
    backgroundColor: '#f6f6f6',
    '&.Mui-focused': {
      backgroundColor: '#e6e6e6 !important',
      color: '#0288d1',
    },
  },
});

const OrderCreatePage = () => {
  const styles = useStyles();
  const api = useAPI();
  const specialSubAccountApi = api.specialSubAccountApi;
  const auth = useAuth();
  const dialog = useDialog();
  const history = useHistory();
  const { memberID } = useParams();

  const formStep1 = useRef();
  const formStep2 = useRef();
  const formStep3 = useRef();

  const [targetMemberID, setTargetMemberID] = useState();

  const [isUnmounted, setIsUnmounted] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [shouldPageDisplay, setShouldPageDisplay] = useState(false);

  const [senderAddressData, setSenderAddressData] = useState({ address: '' });
  const [receiverAddressData, setReceiverAddressData] = useState({
    address: '',
  });

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [doesPrintDialogOpen, setDoesPrintDialogOpen] = useState(false);
  const [printDialogType, setPrintDialogType] = useState('B');
  const [cityList, setCityList] = useState([]);
  const senderDistrictOptions = useRef([]);
  const [senderDistrictName, setSenderDistrictName] = useState('');
  const receiverDistrictOptions = useRef([]);
  const [receiverDistrictName, setReceiverDistrictName] = useState('');
  const storedDeliveryMethods = useRef([]);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState();
  const [weightOptions, setWeightOpeions] = useState();
  const [invoiceTypes, setInvoiceTypes] = useState();
  const [cbmOptions, setCbmOptions] = useState();
  const [canEditEmail, setCanEditEmail] = useState(false);
  const [remarkTemplates, setRemarkTemplates] = useState();
  const [phoneTypePickup, setPhoneTypePickup] = useState('useTel');
  const [phoneTypeReceive, setPhoneTypeReceive] = useState('useTel');
  const [pickupTime, setPickupTime] = useState(
    new Date(Date.now() + 10 * 60 * 1000)
  );
  const [receiveDatetime, setReceiveDatetime] = useState(new Date(Date.now()));
  const [deliveryNoteText, setDeliveryNoteText] = useState('');
  const [remarkShouldUpdate, setRemarkShouldUpdate] = useState(false);
  const [shouldPageUpdate, setShouldPageUpdate] = useState(false);
  const [shouldAmountUpdate, setShouldAmountUpdate] = useState(false);
  const [topData, setTopData] = useState(false);
  const [senderData, setSenderData] = useState(false);
  const [receiverData, setReceiverData] = useState(false);
  const [deliveryNoteData, setDeliveryNoteData] = useState(false);
  const [orderData, setOrderData] = useState(false);
  const [stationData, setStationData] = useState('');
  const [openContactDialog, setOpenContactDialog] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [shippingFee, setShippingFee] = useState(0);
  const [tax, setTax] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [invoiceType, setInvoiceType] = useState('');
  const [paymentMethodId, setPaymentMethodId] = useState();
  const [taxID, setTaxID] = useState('');
  const [shouldInsuranceAmountUpdate, setShouldInsuranceAmountUpdate] =
    useState(false);
  const [showSpecialSubType, setShowSpecialSubType] = useState(false);
  const [specialSubType, setSpecialSubType] = useState(
    SPECIAL_SUB_OPTIONS.USE_SUB
  );
  const [specialSubAcctList, setSpecialSubAcctList] = useState([]);
  const [specialSubDto, setSpecialSubDto] = useState(SPECIAL_SUB_Template);
  const [isMinorServiceCitySender, setIsMinorServiceCitySender] =
    useState(false);
  const [isMinorServiceCityReceiver, setIsMinorServiceCityReceiver] =
    useState(false);

  const [getFeeBufferTrigger, setGetFeeBufferTrigger] = useDebounce(false, 200);
  const [insuranceAmount, setInsuranceAmount] = useDebounce(0, 500);
  const [agencyReceiptAmount, setAgencyReceiptAmount] = useDebounce(0, 500);
  const [prePaidAmount, setPrePaidAmount] = useDebounce(0, 500);

  const [getDeliveryTimeTrigger, setGetDeliveryTimeTrigger] = useDebounce(
    false,
    200
  );

  const countySelectStep1 = useRef(null);
  const countySelectStep2 = useRef(null);
  const referenceEmail = useRef(null);

  const updateInvoiceType = (event) => {
    const paymentMethod = event.target.value;

    setPaymentMethodId(paymentMethod);

    if (PAYMENT_METHOD_NEED_TAXID.has(paymentMethod)) {
      setCanEditEmail(true);
      // 二聯式發票
      setInvoiceType('2');
    } else {
      setCanEditEmail(false);
      // 三聯式發票
      setInvoiceType('1');
    }
  };

  const updateInsuranceAmount = (value) => {
    const insurance = value < 100 ? 0 : Math.floor(value / 100);
    setInsuranceAmount(insurance);
  };

  const checkIsMinorServiceCity = (cityName) => {
    return ['雙北以外'].includes(cityName);
  };

  const getDeliveryMethodsByDistrict = (senderDistrict, receiverDistrict) => {
    if (!storedDeliveryMethods.current) {
      return [];
    }

    const allAreaName = '全省區';

    return (senderDistrict && senderDistrict === allAreaName) ||
      (receiverDistrict && receiverDistrict === allAreaName)
      ? storedDeliveryMethods.current.filter((method) =>
          // 全省, 專件, 特專件
          ['10', '3', '5'].includes(method.value)
        ) || []
      : storedDeliveryMethods.current.filter(
          // 排除全省
          (method) => !['10'].includes(method.value)
        ) || [];
  };

  const getStepTwoDeliveryTime = useCallback(() => {
    if (currentStepIndex !== STEP[2].INDEX || !formStep2.current) {
      return;
    }

    const formData = new FormData(formStep2.current);

    const districtIDString = formData.get('districtReceive') || '';
    const districtID =
      (Number.isNaN(+districtIDString)
        ? districtIDString
        : +districtIDString) || '';

    const data = {
      deliveryMethod: formData.get('deliveryMethod') || '',
      receiveDistrict: districtID,
    };

    api
      .getCreateOrderStepTwoDeliveryTime(data)
      .then((result) => {
        if (result) {
          setReceiveDatetime(new Date(result));
        } else {
          setReceiveDatetime(receiverData.receiveTime || new Date(Date.now()));
        }
      })
      .catch(() => {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepIndex]);

  const getStepThreeFee = useCallback(() => {
    if (
      currentStepIndex !== STEP[3].INDEX ||
      !formStep3 ||
      !formStep3.current ||
      !getFeeBufferTrigger
    )
      return;

    const form = formStep3.current;

    if (!form) return;

    const formData = new FormData(form);

    const parameters = {
      memberID: targetMemberID,
      paymentMethod: formData.get('paymentMethod'),
      agencyReceiptAmount: formData.get('agencyReceiptAmount') || '0',
      prePaidAmount: formData.get('prePaidAmount') || '0',
      insuranceAmount: String(insuranceAmount),
      weightID: formData.get('weight'),
      cbmID: formData.get('cbm'),
    };

    api
      .getCreateOrderStepThreeFee(parameters)
      .then((result) => {
        if (!result) {
          setShippingFee(0);
          setTax(0);
          setTotalAmount(0);
        } else {
          setShippingFee(result.shippingFee);
          setTax(result.tax);
          setTotalAmount(result.totalAmount);
        }
      })
      .catch(() => {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepIndex, getFeeBufferTrigger, insuranceAmount]);

  const setStepFourStations = () => {
    const from = orderData.senderServiceArea || '總站';
    const to = orderData.receiverServiceArea || '總站';
    setStationData(`${from} > ${to}`);
  };

  const submit = () => {
    if (currentStepIndex === STEP[1].INDEX) {
      const form = formStep1.current;
      const formData = new FormData(form);

      const districtIDString = formData.get('districtPickup') || '';
      const districtID =
        (Number.isNaN(+districtIDString)
          ? districtIDString
          : +districtIDString) || '';

      const data = {
        memberID: targetMemberID,
        contactID: formData.get('contactID') || senderData.contactID, // 不知名的參數
        company: formData.get('companyNamePickup') || '',
        contact: formData.get('contactPickup') || '',
        phoneAreaCode: formData.get('areaCodePickup') || '',
        phone: formData.get('telPhonePickup') || '',
        phoneExt: formData.get('extensionNumberPickup') || '',
        mobile: formData.get('mobilePickup') || '',
        isMobilePhone: formData.get('phoneTypePickup') === 'useMobile' || false,
        districtID,
        address: formData.get('addressRoadPickup') || '',
        pickupTime:
          format(new Date(pickupTime || Date.now()), 'yyyy/MM/dd HH:mm') || '',
      };

      api
        .submitCreateOrderStepOne(data)
        .then((isSuccess) => {
          if (isSuccess) {
            nextStep();
          }
        })
        .catch(() => {});

      return;
    } else if (currentStepIndex === STEP[2].INDEX) {
      const form = formStep2.current;
      const formData = new FormData(form);

      const districtIDString = formData.get('districtReceive') || '';
      const districtID =
        (Number.isNaN(+districtIDString)
          ? districtIDString
          : +districtIDString) || '';

      const data = {
        contactID: formData.get('contactID') || receiverData.contactID, // 不知名的參數
        company: formData.get('companyNameReceive') || '',
        contact: formData.get('contactReceive') || '',
        phoneAreaCode: formData.get('areaCodeReceive') || '',
        phone: formData.get('telPhoneReceive') || '',
        phoneExt: formData.get('extensionNumberReceive') || '',
        mobile: formData.get('mobileReceive') || '',
        isMobilePhone:
          formData.get('phoneTypeReceive') === 'useMobile' || false,
        districtID,
        address: formData.get('addressRoadReceive') || '',

        receiveTime:
          format(new Date(receiveDatetime || Date.now()), 'yyyy/MM/dd HH:mm') ||
          '',
        deliveryMethod: formData.get('deliveryMethod'),
      };

      api
        .submitCreateOrderStepTwo(data)
        .then((isSuccess) => {
          if (isSuccess) {
            nextStep();
          }
        })
        .catch(() => {});

      return;
    } else if (currentStepIndex === STEP[3].INDEX) {
      const form = formStep3.current;
      const formData = new FormData(form);
      const getSpecialSubAccount = () => {
        if (!showSpecialSubType) {
          return formData.get('specialSubAccount');
        } else if (specialSubType === SPECIAL_SUB_OPTIONS.USE_SUB) {
          return specialSubDto ? specialSubDto.code : '';
        } else if (specialSubType === SPECIAL_SUB_OPTIONS.USE_OTHER) {
          return formData.get('specialSubOther');
        }
      };

      const data = {
        submitEmail: referenceEmail.current.value, //formData.get('email'),
        specialSubAccount: getSpecialSubAccount(),
        paymentMethodID: formData.get('paymentMethod'),
        taxID: (formData.get('taxID') || '').slice(0, 8),
        invoiceType: formData.get('invoiceType'),
        agencyReceiptAmount: formData.get('agencyReceiptAmount') || '0',
        prePaidAmount: formData.get('prePaidAmount') || '0',
        weightID: formData.get('weight'),
        cbmID: formData.get('cbm'),
        productPrice: formData.get('productPrice'),
        deliveryNote: formData.get('deliveryNote'),
      };

      api
        .submitCreateOrderStepThree(data)
        .then((isSuccess) => {
          if (isSuccess) {
            nextStep();
          }
        })
        .catch(() => {});

      return;
    } else if (currentStepIndex === STEP.FINAL.INDEX) {
      nextStep();
    }
  };

  const selectContact = (contact) => {
    if (currentStepIndex === STEP[1].INDEX) {
      const newSender = JSON.parse(JSON.stringify(senderData));
      setShouldPageUpdate(true);
      setSenderData(Object.assign(newSender, contact));
      setSenderAddressData({ address: contact.address });
    } else if (currentStepIndex === STEP[2].INDEX) {
      const newReceiver = JSON.parse(JSON.stringify(receiverData));
      setShouldPageUpdate(true);
      setReceiverData(Object.assign(newReceiver, contact));
      setReceiverAddressData({ address: contact.address });
    }

    setOpenContactDialog(false);
  };

  const previousStep = () => {
    if (currentStepIndex > STEP[1].INDEX) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const nextStep = () => {
    if (currentStepIndex < STEP.FINAL.INDEX) {
      setCurrentStepIndex(currentStepIndex + 1);
    } else {
      setDoesPrintDialogOpen(true);
    }
  };

  const convertPDF = () => {
    const printList = [];
    printList.push(orderData.orderNumber);
    const printOrderUrl = getHrefUrl(JSON.stringify(printList));
    location.href = printOrderUrl;
  };

  const warningPickupTime = (time) => {
    const validTime = new Date(time || Date.now() + 10 * 60 * 1000);
    const hour = validTime.getHours();
    const minute = validTime.getMinutes();
    if (hour > 16 || (hour === 16 && minute >= 50)) {
      dialog.openAlert({
        message:
          '提醒您，17:00後下訂單當日送市中心（松山、中山、大同、中正、萬華、信義、大安）為專件計價，送新北市、市郊為特專件計價。',
      });
    } else if (hour > 15 || (hour === 15 && minute >= 50)) {
      dialog.openAlert({
        message:
          '提醒您，16:00後下訂單當日送新北市、市郊（士林、北投、南港、內湖、文山）為專件計價。',
      });
    }

    setPickupTime(validTime);
  };

  useEffect(() => {
    if (currentStepIndex === STEP[2].INDEX) {
      api
        .getCreateOrderStepTwoDefault()
        .then((result) => {
          storedDeliveryMethods.current = result.delivery;
          setReceiverDistrictName(result.receiverData.districtName);
          setReceiverData(result.receiverData);
          setReceiverAddressData({ address: result.receiverData.address });
        })
        .catch(() => {});
    } else if (currentStepIndex === STEP[3].INDEX) {
      api
        .getCreateOrderStepThreeDefault()
        .then((result) => {
          if (
            !(
              result.deliveryNoteData &&
              result.paymentMethodOptions &&
              result.invoicePaymentMethodType &&
              result.weightOptions &&
              result.cbmOptions &&
              result.deliveryNoteOptions
            )
          )
            dialog.openAlert({ message: '抓取參數時發生錯誤' });

          setPaymentMethodOptions(result.paymentMethodOptions);
          setInvoiceTypes(result.invoicePaymentMethodType);
          setWeightOpeions(result.weightOptions);
          setCbmOptions(result.cbmOptions);
          setRemarkTemplates(result.deliveryNoteOptions);

          setDeliveryNoteData(result.deliveryNoteData);
        })
        .catch(() => {});
    } else if (currentStepIndex === STEP.FINAL.INDEX) {
      api
        .getCreateOrderStepFourDefault()
        .then((result) => {
          if (result && result.orderData) {
            setOrderData(result.orderData);
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepIndex]);

  useEffect(() => {
    // 二聯式發票
    if (invoiceType === '2') {
      setTaxID('');
    } else {
      setTaxID(deliveryNoteData.taxID);
    }
  }, [deliveryNoteData.taxID, invoiceType, invoiceTypes]);

  useEffect(() => {
    setShouldInsuranceAmountUpdate(true);
  }, [insuranceAmount]);

  useEffect(() => {
    if (getFeeBufferTrigger) {
      getStepThreeFee();
    }
  }, [getFeeBufferTrigger, getStepThreeFee, setGetFeeBufferTrigger]);

  useEffect(() => {
    if (getDeliveryTimeTrigger) {
      getStepTwoDeliveryTime();
    }
  }, [getDeliveryTimeTrigger, getStepTwoDeliveryTime]);

  useEffect(() => {
    setGetFeeBufferTrigger(false);
  }, [getFeeBufferTrigger, setGetFeeBufferTrigger]);

  useEffect(() => {
    setGetDeliveryTimeTrigger(false);
  }, [getDeliveryTimeTrigger, setGetDeliveryTimeTrigger]);

  useEffect(() => {
    if (!getFeeBufferTrigger) setGetFeeBufferTrigger(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    insuranceAmount,
    agencyReceiptAmount,
    prePaidAmount,
    setGetFeeBufferTrigger,
  ]);

  useEffect(() => {
    if (!getDeliveryTimeTrigger) setGetDeliveryTimeTrigger(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setGetDeliveryTimeTrigger]);

  useEffect(() => {
    setShouldInsuranceAmountUpdate(false);
  }, [shouldInsuranceAmountUpdate]);

  useEffect(() => {
    setRemarkShouldUpdate(true);
  }, [deliveryNoteText]);

  useEffect(() => {
    setRemarkShouldUpdate(false);
  }, [remarkShouldUpdate]);

  useEffect(
    () => () => {
      setIsUnmounted(true);
    },
    []
  );

  useEffect(() => {
    if (targetMemberID) return;
    if (!memberID) setTargetMemberID(auth.user.memberID);
    else setTargetMemberID(memberID);
  }, [auth.user.memberID, memberID, targetMemberID]);

  useEffect(() => {
    if (targetMemberID && !pageLoaded) {
      const loadCitys = api
        .getDropdownCitys()
        .then((citys) => {
          if (!isUnmounted) {
            setCityList(citys);
          }
        })
        .catch(() => {});

      specialSubAccountApi
        .fetchList({
          page: 1,
          pageSize: 1000,
          memberId: memberID,
        })
        .then((data) => {
          if (data && data.rowList && data.rowList.length > 0) {
            setShowSpecialSubType(true);
            setSpecialSubAcctList(data.rowList);
          }
        });

      const loadingQueries = [loadCitys];

      Promise.all(loadingQueries).then(() => {
        setPageLoaded(true);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnmounted, pageLoaded, targetMemberID]);

  useEffect(() => {
    if (!pageLoaded) return;

    api
      .getOrderContacts({ memberID: targetMemberID })
      .then((contactListData) => {
        if (!isUnmounted) {
          setContactList(contactListData);
        }
      })
      .catch(() => {});

    api
      .getCreateOrderStepOneDefault({ memberID: targetMemberID })
      .then((data) => {
        if (!isUnmounted) {
          setTopData(data.topData);
          setSenderData(data.senderData);
          setSenderAddressData({ address: data.senderData.address });
        }
      })
      .catch(() => {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLoaded]);

  useEffect(() => {
    if (!topData || !senderData) return;

    if (senderData.isMobilePhone) {
      setPhoneTypePickup('useMobile');
    }

    warningPickupTime(senderData.pickUpTime);

    if (!shouldPageDisplay) setShouldPageDisplay(true);
    else setShouldPageUpdate(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topData, senderData]);

  useEffect(() => {
    if (!receiverData) return;

    if (receiverData.isMobilePhone) {
      setPhoneTypeReceive('useMobile');
    }

    setReceiveDatetime(receiverData.receiveTime || new Date(Date.now()));

    setShouldPageUpdate(true);
  }, [receiverData]);

  useEffect(() => {
    if (!deliveryNoteData) return;

    if (deliveryNoteData.deliveryNote) {
      setDeliveryNoteText(deliveryNoteData.deliveryNote);
    }

    setInsuranceAmount(deliveryNoteData.insuranceAmount);
    setAgencyReceiptAmount(deliveryNoteData.agencyReceiptAmount);
    setPrePaidAmount(deliveryNoteData.prePaidAmount);
    setInvoiceType(deliveryNoteData.invoiceType);
    setPaymentMethodId(deliveryNoteData.paymentMethodID);
    setTaxID(deliveryNoteData.taxID);

    setShouldPageUpdate(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryNoteData]);

  useEffect(() => {
    if (!orderData) return;
    setShouldPageUpdate(true);
    setStepFourStations();

    setPrintDialogType(
      orderData.senderCompany === topData.mandarinName ? 'A' : 'B'
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  useEffect(() => {
    setShouldPageUpdate(true);
  }, [stationData]);

  useEffect(() => {
    setShouldPageUpdate(false);
    if (!getFeeBufferTrigger) setGetFeeBufferTrigger(true);
    if (!getDeliveryTimeTrigger) setGetDeliveryTimeTrigger(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldPageUpdate, setGetFeeBufferTrigger, setGetDeliveryTimeTrigger]);

  useEffect(() => {
    setShouldAmountUpdate(false);
  }, [shouldAmountUpdate]);

  useEffect(() => {
    if (!shouldAmountUpdate) setShouldAmountUpdate(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingFee, tax, totalAmount]);

  // const isChinese = (input) => {
  //   api;
  //   const reg = /^[\u4E00-\u9FA5]+$/;
  //   return reg.test(input) ? true : false;
  // };

  // const isNam = (input) => {
  //   api;
  //   return Number.parseFloat(input).toString() === 'NaN' ? false : true;
  // };

  return (
    <>
      {!shouldPageUpdate && shouldPageDisplay ? (
        <>
          <Paper
            elevation={4}
            sx={{
              padding: 2,
              paddingBottom: 0,
              marginTop: 4,
              marginBottom: 8,
              maxWidth: '900px',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            <Box marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                會員編號：
              </Typography>
              <Typography display="inline">{topData.accountCode}</Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                中文名稱：
              </Typography>
              <Typography display="inline">{topData.mandarinName}</Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                姓名：
              </Typography>
              <Typography display="inline">{topData.name}</Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                電話：
              </Typography>
              <Typography display="inline">{topData.tel}</Typography>
            </Box>
            <Box variant="body" marginRight={4} marginBottom={2}>
              <Typography display="inline" fontWeight="bold">
                付款方式：
              </Typography>
              <Typography display="inline">{topData.paymentType}</Typography>
            </Box>
          </Paper>
          <Box sx={{ width: '100%' }}>
            <Stepper activeStep={currentStepIndex} alternativeLabel>
              {STEPS.map((STEP) => (
                <Step key={STEP.NAME}>
                  <StepLabel>{STEP.NAME}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
          {/* STEP[1] 取件方 */}
          <Paper
            ref={formStep1}
            component="form"
            elevation={4}
            sx={{
              padding: 2,
              paddingBottom: 4,
              marginTop: 4,
              marginBottom: 4,
              maxWidth: '900px',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: currentStepIndex === STEP[1].INDEX ? 'flex' : 'none', // STEP[1] 取件方
              flexWrap: 'wrap',
            }}
          >
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="info"
              startIcon={<ContactMailIcon />}
              sx={{ color: 'white', maxWidth: '160px', marginBottom: 2 }}
              onClick={() => setOpenContactDialog(true)}
            >
              選擇常用聯絡人
            </Button>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  label="公司"
                  name="companyNamePickup"
                  defaultValue={senderData.company}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="聯絡人"
                  name="contactPickup"
                  defaultValue={senderData.contact}
                />
              </Grid>

              <Grid item xs={12} marginTop={2}>
                <FormLabel>電話</FormLabel>
              </Grid>

              <Grid item xs={12} sm={6} textAlign="center">
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    aria-label="phoneTypePickup"
                    name="phoneTypePickup"
                    value={phoneTypePickup}
                    onChange={(event) => setPhoneTypePickup(event.target.value)}
                  >
                    <FormControlLabel
                      value="useTel"
                      control={<Radio />}
                      label="公司電話"
                      sx={{ paddingTop: 1 }}
                    />
                    <FormControlLabel
                      value="useMobile"
                      control={<Radio />}
                      label="行動電話"
                      sx={{ paddingTop: 1 }}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                container
                alignItems="center"
                sx={{
                  display: phoneTypePickup === 'useTel' ? 'flex' : 'none',
                  position: 'relative',
                  marginTop: '8px',
                  paddingTop: '18px !important',
                  justifyContent: 'space-between',
                }}
              >
                <Grid item xs={3}>
                  <TextField
                    name="areaCodePickup"
                    type="tel"
                    autoComplete="none"
                    label="區碼"
                    size="small"
                    fullWidth
                    sx={{ padding: 1 }}
                    defaultValue={senderData.phoneAreaCode}
                  />
                </Grid>
                <div>-</div>
                <Grid item xs={5} sx={{ paddingLeft: 0 }}>
                  <TextField
                    name="telPhonePickup"
                    type="tel"
                    autoComplete="none"
                    label="電話號碼"
                    size="small"
                    fullWidth
                    defaultValue={senderData.phone}
                  />
                </Grid>
                <div>#</div>
                <Grid item xs={3}>
                  <TextField
                    name="extensionNumberPickup"
                    type="tel"
                    autoComplete="none"
                    label="分機"
                    size="small"
                    fullWidth
                    sx={{ padding: 1 }}
                    defaultValue={senderData.phoneExt}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: phoneTypePickup === 'useMobile' ? 'flex' : 'none',
                }}
              >
                <TextField
                  required
                  fullWidth
                  label="行動電話"
                  name="mobilePickup"
                  type="tel"
                  size="small"
                  sx={{ marginTop: '10px' }}
                  defaultValue={senderData.mobile}
                />
              </Grid>

              <Grid item xs={12} marginTop={2}>
                <FormLabel>地址</FormLabel>
              </Grid>

              <CombineSelector
                xs={12}
                sm={6}
                md={3}
                isVariable={false}
                inputRef={countySelectStep1}
                optionsList={{
                  firstName: 'cityPickup',
                  firstLabel: '縣市',
                  options: cityList,
                  secondName: 'districtPickup',
                  secondLabel: '區域',
                  firstValue: senderData.cityName,
                  secondValue: senderData.districtID,
                }}
                secondOptionsKeyName="districts"
                onFirstChange={(cityName) => {
                  setIsMinorServiceCitySender(
                    checkIsMinorServiceCity(cityName)
                  );

                  if (cityList && cityList.length > 0) {
                    const selectedCity = cityList.find(
                      (city) => city.text === cityName
                    );

                    if (selectedCity) {
                      senderDistrictOptions.current =
                        selectedCity && selectedCity.districts;
                    }
                  }
                }}
                onSecondChange={(districtId) => {
                  if (districtId && senderDistrictOptions.current) {
                    const selectedDistrict = senderDistrictOptions.current.find(
                      (district) => district.value === districtId
                    );

                    if (selectedDistrict && selectedDistrict.text) {
                      setSenderDistrictName(selectedDistrict.text);
                    }
                  }
                }}
                variant="outlined"
              />

              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  required
                  name="addressRoadPickup"
                  label={
                    isMinorServiceCitySender === true
                      ? '請輸入完整地址'
                      : '請輸入地址'
                  }
                  helperText={
                    isMinorServiceCitySender === true
                      ? '例:臺中市西區民權路69號'
                      : '例:忠孝東路三段150號'
                  }
                  value={senderAddressData.address}
                  onChange={(event) => {
                    const addressData = event.target.value;
                    if (addressData) {
                      setSenderAddressData({ address: addressData });
                    } else {
                      setSenderAddressData({ address: '' });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} marginTop={2}>
                <FormLabel>取件時間</FormLabel>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack>
                  <DateTimePicker
                    renderInput={(properties) => <TextField {...properties} />}
                    ampm={false}
                    disablePast
                    cancelText="取消"
                    okText="確定"
                    value={pickupTime}
                    onChange={setPickupTime}
                    onAccept={warningPickupTime}
                    disableMaskedInput
                    inputFormat={'yyyy-MM-dd HH:mm'}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Paper>
          {/* STEP[2] 送達方 */}
          <Paper
            ref={formStep2}
            component="form"
            elevation={4}
            sx={{
              padding: 2,
              paddingBottom: 4,
              marginTop: 4,
              marginBottom: 4,
              maxWidth: '900px',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: currentStepIndex === STEP[2].INDEX ? 'flex' : 'none', // STEP[2] 送達方
              flexWrap: 'wrap',
            }}
          >
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="info"
              startIcon={<ContactMailIcon />}
              sx={{ color: 'white', maxWidth: '160px', marginBottom: 2 }}
              onClick={() => setOpenContactDialog(true)}
            >
              選擇常用聯絡人
            </Button>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  required
                  label="公司"
                  name="companyNameReceive"
                  defaultValue={receiverData.company}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="聯絡人"
                  name="contactReceive"
                  defaultValue={receiverData.contact}
                />
              </Grid>

              <Grid item xs={12} marginTop={2}>
                <FormLabel>電話</FormLabel>
              </Grid>

              <Grid item xs={12} sm={6} textAlign="center">
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    aria-label="phoneTypeReceive"
                    name="phoneTypeReceive"
                    value={phoneTypeReceive}
                    onChange={(event) =>
                      setPhoneTypeReceive(event.target.value)
                    }
                  >
                    <FormControlLabel
                      value="useTel"
                      control={<Radio />}
                      label="公司電話"
                      sx={{ paddingTop: 1 }}
                    />
                    <FormControlLabel
                      value="useMobile"
                      control={<Radio />}
                      label="行動電話"
                      sx={{ paddingTop: 1 }}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                container
                alignItems="center"
                sx={{
                  display: phoneTypeReceive === 'useTel' ? 'flex' : 'none',
                  position: 'relative',
                  marginTop: '8px',
                  paddingTop: '18px !important',
                  justifyContent: 'space-between',
                }}
              >
                <Grid item xs={3}>
                  <TextField
                    name="areaCodeReceive"
                    type="tel"
                    autoComplete="none"
                    label="區碼"
                    size="small"
                    fullWidth
                    sx={{ padding: 1 }}
                    defaultValue={receiverData.phoneAreaCode}
                  />
                </Grid>
                <div>-</div>
                <Grid item xs={5} sx={{ paddingLeft: 0 }}>
                  <TextField
                    name="telPhoneReceive"
                    type="tel"
                    autoComplete="none"
                    label="電話號碼"
                    size="small"
                    fullWidth
                    defaultValue={receiverData.phone}
                  />
                </Grid>
                <div>#</div>
                <Grid item xs={3}>
                  <TextField
                    name="extensionNumberReceive"
                    type="tel"
                    autoComplete="none"
                    label="分機"
                    size="small"
                    fullWidth
                    sx={{ padding: 1 }}
                    defaultValue={receiverData.phoneExt}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: phoneTypeReceive === 'useMobile' ? 'flex' : 'none',
                }}
              >
                <TextField
                  required
                  fullWidth
                  label="行動電話"
                  name="mobileReceive"
                  type="tel"
                  size="small"
                  sx={{ marginTop: '10px' }}
                  defaultValue={receiverData.mobile}
                />
              </Grid>

              <Grid item xs={12} marginTop={2}>
                <FormLabel>地址</FormLabel>
              </Grid>

              <CombineSelector
                xs={12}
                sm={6}
                md={3}
                isVariable={false}
                inputRef={countySelectStep2}
                optionsList={{
                  options: cityList,
                  firstName: 'cityReceive',
                  firstLabel: '縣市',
                  firstValue: receiverData.cityName,
                  secondName: 'districtReceive',
                  secondLabel: '區域',
                  secondValue: receiverData.districtID,
                }}
                secondOptionsKeyName="districts"
                variant="outlined"
                onFirstChange={(cityName) => {
                  setIsMinorServiceCityReceiver(
                    checkIsMinorServiceCity(cityName)
                  );
                  if (cityList && cityList.length > 0) {
                    const selectedCity = cityList.find(
                      (city) => city.text === cityName
                    );

                    if (selectedCity) {
                      receiverDistrictOptions.current =
                        selectedCity && selectedCity.districts;
                    }
                  }
                }}
                onSecondChange={(districtId) => {
                  if (districtId && receiverDistrictOptions.current) {
                    const selectedDistrict =
                      receiverDistrictOptions.current.find(
                        (district) => district.value === districtId
                      );

                    if (selectedDistrict && selectedDistrict.text) {
                      setReceiverDistrictName(selectedDistrict.text);
                    }
                  }
                }}
              />

              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  required
                  name="addressRoadReceive"
                  value={receiverAddressData.address}
                  label={
                    isMinorServiceCityReceiver === true
                      ? '請輸入完整地址'
                      : '請輸入地址'
                  }
                  helperText={
                    isMinorServiceCityReceiver === true
                      ? '例:臺中市西區民權路69號'
                      : '例:忠孝東路三段150號'
                  }
                  onChange={(event) => {
                    const addressData = event.target.value;

                    if (addressData) {
                      setReceiverAddressData({ address: addressData });
                    } else {
                      setReceiverAddressData({ address: '' });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} marginTop={2}>
                <FormLabel>送達時間</FormLabel>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack>
                  <DateTimePicker
                    renderInput={(properties) => <TextField {...properties} />}
                    ampm={false}
                    disablePast
                    cancelText="取消"
                    okText="確定"
                    value={pickupTime}
                    onChange={(newValue) => setReceiveDatetime(newValue)}
                    disableMaskedInput
                    inputFormat={'yyyy-MM-dd HH:mm'}
                  />
                  <FormHelperText id="receive-datetime-helper-text">
                    若為偏遠地區或山區，會再增加1小時配送時間
                  </FormHelperText>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Selector
                  name="deliveryMethod"
                  label="遞送方式"
                  placeHolder="遞送方式"
                  options={getDeliveryMethodsByDistrict(
                    senderDistrictName,
                    receiverDistrictName
                  )}
                  variant="outlined"
                  required
                  fullWidth
                  defaultValue={
                    storedDeliveryMethods.current &&
                    storedDeliveryMethods.current.some(
                      (method) => method.value === receiverData.deliveryMethod
                    )
                      ? receiverData.deliveryMethod
                      : ''
                  }
                  onChange={(event) => {
                    if (receiverData) {
                      receiverData.deliveryMethod = event.target.value;
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
          {/* STEP[3] 配送訊息 */}
          <Paper
            ref={formStep3}
            component="form"
            elevation={4}
            sx={{
              padding: 2,
              paddingBottom: 4,
              marginTop: 4,
              marginBottom: 4,
              maxWidth: '900px',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: currentStepIndex === STEP[3].INDEX ? 'flex' : 'none', // STEP[3] 配送訊息
              flexWrap: 'wrap',
            }}
          >
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={6}>
                <VariableTextField
                  label="登錄日期"
                  name="signInDatetime"
                  text={deliveryNoteData.createDate}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  name="email"
                  inputRef={referenceEmail}
                  label="電子郵件"
                  defaultValue={
                    deliveryNoteData.companyEmail ||
                    deliveryNoteData.personalEmail
                  }
                  variant={canEditEmail ? 'standard' : 'filled'}
                  disabled={canEditEmail ? false : true}
                  fullWidth
                  required
                />
              </Grid>
              {showSpecialSubType ? (
                <>
                  <Grid item xs={12} sm={6}>
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="specialSubType"
                        name="specialSubType"
                        value={specialSubType}
                        onChange={(event) =>
                          setSpecialSubType(event.target.value)
                        }
                      >
                        <FormControlLabel
                          value={SPECIAL_SUB_OPTIONS.USE_SUB}
                          control={<Radio />}
                          label="特殊分帳"
                          sx={{ paddingTop: 1 }}
                        />
                        <FormControlLabel
                          value={SPECIAL_SUB_OPTIONS.USE_OTHER}
                          control={<Radio />}
                          label="另填完整請款卡號"
                          sx={{ paddingTop: 1 }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} />
                </>
              ) : undefined}
              {showSpecialSubType ? (
                <>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      display:
                        specialSubType === SPECIAL_SUB_OPTIONS.USE_SUB
                          ? 'flex'
                          : 'none',
                    }}
                  >
                    <Autocomplete
                      fullWidth
                      classes={{ option: styles.option }}
                      options={specialSubAcctList}
                      getOptionLabel={(option) =>
                        `${option.code} ${option.description}`
                      }
                      clearOnEscape
                      onChange={(event, chosenData) => {
                        setSpecialSubDto(chosenData ? chosenData : null);
                      }}
                      renderInput={(parameters) => (
                        <TextField
                          {...parameters}
                          fullWidth
                          label="特殊分帳"
                          helperText="輸入關鍵字可搜尋"
                        />
                      )}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      display:
                        specialSubType === SPECIAL_SUB_OPTIONS.USE_OTHER
                          ? 'flex'
                          : 'none',
                    }}
                  >
                    <TextField
                      fullWidth
                      label="請款卡號"
                      helperText="請填寫請款卡號"
                      name="specialSubOther"
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="特殊分帳"
                    name="specialSubAccount"
                    defaultValue={deliveryNoteData.SpecialSubAccount}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                {paymentMethodOptions ? (
                  <Selector
                    name="paymentMethod"
                    label="付款方式"
                    placeHolder="付款方式"
                    options={paymentMethodOptions}
                    variant="outlined"
                    required
                    fullWidth
                    defaultValue={
                      paymentMethodOptions.some(
                        (option) =>
                          option.value === deliveryNoteData.paymentMethodID
                      )
                        ? deliveryNoteData.paymentMethodID
                        : ''
                    }
                    onChange={(event) => {
                      updateInvoiceType(event);
                      setGetFeeBufferTrigger(true);
                    }}
                  />
                ) : undefined}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="公司統編"
                  name="taxID"
                  value={taxID || ''}
                  onChange={(event) => setTaxID(event.target.value)}
                  inputProps={{
                    // 預購或月結都不可修改統編
                    readOnly: ['1', '2'].includes(paymentMethodId),
                  }}
                  disabled={invoiceType === '2'} // 二聯式發票
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <VariableTextField
                  label="中文名稱"
                  name="chineseName"
                  text={deliveryNoteData.mandarinName}
                  displayInSmall={false}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                {invoiceTypes ? (
                  <Selector
                    name="invoiceType"
                    label="發票"
                    placeHolder="發票"
                    options={invoiceTypes}
                    variant="outlined"
                    required
                    fullWidth
                    defaultValue={invoiceType}
                    onChange={(event) => setInvoiceType(event.target.value)}
                  />
                ) : undefined}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="代收款"
                  name="agencyReceiptAmount"
                  defaultValue={deliveryNoteData.agencyReceiptAmount}
                  onChange={(event) =>
                    setAgencyReceiptAmount(event.target.value)
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  label="代墊款"
                  name="prePaidAmount"
                  defaultValue={deliveryNoteData.prePaidAmount}
                  onChange={(event) => setPrePaidAmount(event.target.value)}
                />
              </Grid>

              <Grid item xs={11} sm={5}>
                {weightOptions ? (
                  <Selector
                    name="weight"
                    label="重量"
                    placeHolder="重量"
                    options={weightOptions}
                    variant="outlined"
                    required
                    fullWidth
                    defaultValue={deliveryNoteData.weightID}
                    onChange={() => setGetFeeBufferTrigger(true)}
                  />
                ) : undefined}
              </Grid>
              <Grid
                item
                xs={11}
                sm={1}
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                KG
              </Grid>

              <Grid item xs={12} sm={4}>
                {cbmOptions ? (
                  <Selector
                    name="cbm"
                    label="材積"
                    placeHolder="材積"
                    options={cbmOptions}
                    variant="outlined"
                    required
                    fullWidth
                    defaultValue={deliveryNoteData.cbmID}
                    onChange={() => setGetFeeBufferTrigger(true)}
                  />
                ) : undefined}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  fullWidth
                  label="商品價值"
                  name="productPrice"
                  defaultValue={deliveryNoteData.productPrice}
                  onChange={(event) =>
                    updateInsuranceAmount(event.target.value)
                  }
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                {!shouldInsuranceAmountUpdate ? (
                  <VariableTextField
                    locked
                    required
                    fullWidth
                    label="保值"
                    name="insuranceAmount"
                    text={insuranceAmount}
                    onChange={() => setGetFeeBufferTrigger(true)}
                  />
                ) : undefined}
              </Grid>

              <Grid item xs={12}>
                {!remarkShouldUpdate ? (
                  <TextField
                    required
                    fullWidth
                    label="備註"
                    name="deliveryNote"
                    defaultValue={deliveryNoteText}
                  />
                ) : undefined}
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: 'flex', flexWrap: 'wrap', marginBottom: -1 }}
              >
                {remarkTemplates &&
                  remarkTemplates.map((option, index) => (
                    <Button
                      key={`${option.text}-${index}`}
                      type="button"
                      variant="contained"
                      color="info"
                      sx={{ color: 'white', marginRight: 2, marginBottom: 1 }}
                      onClick={() => setDeliveryNoteText(option.text || '')}
                    >
                      {option.text || ''}
                    </Button>
                  ))}
              </Grid>
              <Grid item xs={12} sm={4}>
                {!shouldAmountUpdate ? (
                  <VariableTextField
                    label="合計運費"
                    name="shippingFee"
                    text={shippingFee || '議價'}
                  />
                ) : (
                  '0'
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                {!shouldAmountUpdate ? (
                  <VariableTextField label="稅額" name="tax" text={tax} />
                ) : (
                  '0'
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                {!shouldAmountUpdate ? (
                  <VariableTextField
                    label="應收金額"
                    name="totalAmount"
                    text={totalAmount}
                  />
                ) : (
                  '0'
                )}
              </Grid>
            </Grid>
          </Paper>
          {/* STEP.FINAL 列印簽單 */}
          <Paper
            elevation={4}
            sx={{
              padding: 2,
              paddingBottom: 4,
              marginTop: 4,
              marginBottom: 4,
              maxWidth: '900px',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: currentStepIndex === STEP.FINAL.INDEX ? 'flex' : 'none', // STEP.FINAL 列印簽單
              flexWrap: 'wrap',
            }}
          >
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="訂單編號"
                  name="orderNumber"
                  text={orderData.orderNumber}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="服務區"
                  name="endPointStation"
                  text={stationData}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="日期"
                  name="date"
                  text={orderData.createDate}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="會員編號"
                  name="accountCode"
                  text={orderData.senderAccountCode}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="代收款"
                  name="collectionPriceSummary"
                  text={orderData.agencyReciptAmount}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="代墊款"
                  name="advancePriceSummary"
                  text={orderData.prePaidAmount}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="取件方"
                  name="pickupSide"
                  text={orderData.senderCompany}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="聯絡人"
                  name="pickupContactSummary"
                  text={orderData.senderContactName}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="電話"
                  name="pickupPhoneNumberSummary"
                  text={orderData.senderPhone}
                />
              </Grid>

              <Grid item xs={12}>
                <VariableTextField
                  label="地址"
                  name="pickupAddressSummary"
                  text={orderData.senderFullAddress}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="送達方"
                  name="receiveSide"
                  text={orderData.receiverCompany}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="聯絡人"
                  name="receiveContactSummary"
                  text={orderData.receiverContactName}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="電話"
                  name="receivePhoneNumberSummary"
                  text={orderData.receiverPhone}
                />
              </Grid>

              <Grid item xs={12}>
                <VariableTextField
                  label="地址"
                  name="receiveAddressSummary"
                  text={orderData.receiverFullAddress}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="運費"
                  name="shippingPriceSummary"
                  text={orderData.shippingFee}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="材積"
                  name="VolumeSummary"
                  text={orderData.cbm}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <VariableTextField
                  label="備註"
                  name="remarkSummary"
                  text={orderData.deliveryNote}
                />
              </Grid>

              <Grid item xs={12}>
                <VariableTextField
                  label="遞送方式"
                  name="deliveryMethodSummary"
                  text={orderData.deliveryMethod}
                />
              </Grid>
            </Grid>
          </Paper>
          <Grid
            container
            spacing={3}
            sx={{ margin: 'auto', width: '100%', justifyContent: 'center' }}
          >
            {currentStepIndex > STEP[1].INDEX &&
            currentStepIndex < STEP.FINAL.INDEX ? (
              <Grid item xs={12} sx={{ maxWidth: '200px' }}>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="warning"
                  sx={{ color: 'white' }}
                  onClick={previousStep}
                >
                  上一步
                </Button>
              </Grid>
            ) : undefined}
            <Grid item xs={12} sx={{ maxWidth: '200px' }}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="success"
                sx={{ color: 'white' }}
                onClick={submit}
              >
                {currentStepIndex < STEP[3].INDEX
                  ? '下一步'
                  : currentStepIndex === STEP[3].INDEX
                  ? '下訂單'
                  : currentStepIndex === STEP.FINAL.INDEX
                  ? '確認'
                  : ''}
              </Button>
            </Grid>
          </Grid>
          <Dialog
            open={doesPrintDialogOpen}
            title=""
            confirmText="關閉"
            confirmColor="error"
            onClose={() => setDoesPrintDialogOpen(false)}
            onConfirm={() => setDoesPrintDialogOpen(false)}
            isConfirm={false}
          >
            {printDialogType === 'A' ? (
              <Typography variant="h5" marginBottom={2}>
                請選擇下列列印方式：
              </Typography>
            ) : printDialogType === 'B' ? (
              <Typography
                variant="h5"
                marginBottom={3}
                sx={{
                  backgroundColor: colors.red[500],
                  padding: 2,
                  color: 'white',
                }}
              >
                請將PDF檔傳給對方，並黏貼在包裹上
              </Typography>
            ) : (
              ''
            )}

            <Button
              type="button"
              fullWidth
              variant="contained"
              color="secondary"
              sx={{ color: 'white', marginBottom: 3 }}
              startIcon={<PictureAsPdfIcon />}
              onClick={convertPDF}
            >
              轉出PDF檔
            </Button>
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="secondary"
              sx={{ color: 'white', marginBottom: 3 }}
              startIcon={<LibraryBooksIcon />}
              onClick={() => history.replace('/record/list')}
            >
              前往案件紀錄
            </Button>
            <Typography variant="body2">
              提醒：將列印好的標籤，貼在包裹上
            </Typography>
          </Dialog>{' '}
        </>
      ) : undefined}

      <Dialog
        open={openContactDialog}
        title="選擇常用聯絡人"
        onClose={() => setOpenContactDialog(false)}
        onConfirm={() => setOpenContactDialog(false)}
        min={290}
      >
        {contactList.map((contact, index) => (
          <Paper
            key={String(contact.contactID) + String(index)}
            elevation={2}
            sx={{
              minWidth: 200,
              height: '100%',
              backgroundColor: '#f0f0f0',
              marginBottom: 2,
            }}
            onClick={() => selectContact(contact)}
          >
            <Box sx={{ padding: 2 }}>
              <Typography>姓名：{contact.contact}</Typography>
              <Typography>公司：{contact.company}</Typography>
              <Typography>電話：{contact.phone || contact.mobile}</Typography>
              <Typography>地址：{contact.address}</Typography>
            </Box>
          </Paper>
        ))}
      </Dialog>
    </>
  );
};

export default OrderCreatePage;
